export default __webpack_public_path__ + "static/oh-logo-f7a4883c0d6dbb24b1c3d29efb62a1cc.png";